/**
 *
 * @module entry
 * @desc {SDK.Services.Purchase} entry point.
 *
 */

import PurchaseClient from './purchaseClient';
import PurchaseClientConfiguration from './purchaseClientConfiguration';
import PurchaseClientEndpoint from './purchaseClientEndpoint';
import PurchaseActivation from './purchaseActivation';
import PurchaseActivationResult from './purchaseActivationResult';
import PurchaseActivationStatus from './purchaseActivationStatus';
import ReceiptCredentials from './receiptCredentials';

/**
 *
 * @typedef SDK.Services.Purchase
 * @type {Object}
 *
 * @property {PurchaseClient} PurchaseClient
 * @property {PurchaseClientConfiguration} PurchaseClientConfiguration
 * @property {PurchaseClientEndpoint} PurchaseClientEndpoint
 * @property {PurchaseActivation} PurchaseActivation
 * @property {PurchaseActivationResult} PurchaseActivationResult
 * @property {PurchaseActivationStatus} PurchaseActivationStatus
 * @property {ReceiptCredentials} ReceiptCredentials
 *
 */

/**
 *
 * @type {SDK.Services.Purchase}
 *
 */
export default {

    PurchaseClient,
    PurchaseClientConfiguration,
    PurchaseClientEndpoint,
    PurchaseActivation,
    PurchaseActivationResult,
    PurchaseActivationStatus,
    ReceiptCredentials

};



// WEBPACK FOOTER //
// ./src/services/purchase/entry.js